import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class NacexAccountsService {
    async getAll() {
        try {
            const response = await axios.get(`${config["apiUrl"]}nacex/accounts`, {
                headers: authHeader(),
            });
            return response.status === 200 ? response.data : [];
        } catch (error) {
            this.handleError(error);
            return [];
        }
    }

    async create(data) {
        try {
            const response = await axios.post(`${config["apiUrl"]}nacex/accounts`, data, {
                headers: authHeader(),
            });
            return response.status === 201 ? response.data : null;
        } catch (error) {
            this.handleError(error);
            return error.response?.data || null;
        }
    }

    async update(id, data) {
        try {
            const response = await axios.put(`${config["apiUrl"]}nacex/accounts/${id}`, data, {
                headers: authHeader(),
            });
            return response.status === 200 ? response.data : null;
        } catch (error) {
            this.handleError(error);
            return error.response?.data || null;
        }
    }

    async delete(id) {
        try {
            const response = await axios.delete(`${config["apiUrl"]}nacex/accounts/${id}`, {
                headers: authHeader(),
            });
            return response.status === 200 ? response.data : null;
        } catch (error) {
            this.handleError(error);
            return error.response?.data || null;
        }
    }

    handleError(error) {
        if (error.response?.status === 401) {
            AuthService.logout();
            window.location = "/login";
        }
        console.error("NACEX Accounts Service Error: ", error.response?.data);
    }
}

export default new NacexAccountsService();
